import { baseUrl, headers, jwtHeaders } from '../common/data';

export const fetchAOwner = async (id) => {
  const response = await fetch(`${baseUrl}/api/owner/getaowner/${id}`, {
    method: 'GET',
    headers,
    redirect: 'follow',
  });
  const resData = response.json();
  return resData;
};

export const createOwner = async (data) => {
  const response = await fetch(`${baseUrl}/api/owner/createowner`, {
    method: 'POST',
    // headers: headers,
    body: data,
    // redirect: 'follow',
  });
  const resData = await response?.json();

  return resData;
};

export const getAllOwners = async (queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/owner/getallowner${queryParams ? queryParams : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();

  return resData;
};

export const deleteOwner = async (id) => {
  const response = await fetch(`${baseUrl}/api/owner/deleteowner/${id}`, {
    method: 'DELETE',
    headers: headers,
    redirect: 'follow',
  });
  const resData = await response?.json();

  return resData;
};

export const changeStatus = async (id, data) => {
  const response = await fetch(`${baseUrl}/api/owner/owneractivestatus/${id}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers,
  });
  const resData = await response?.json();
  return resData;
};

export const updateOwnerSubscription = async (data, id) => {
  const response = await fetch(`${baseUrl}/api/owner/updateownersubscription/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: headers,
  });
  const resData = response?.json();

  return resData;
};
